export default __webpack_public_path__ + "static/media/nakisanze.6d725e76.png";